export const commonEuropeanLanguages = [
    { id: 1, name: 'Español', "code": "es" },
    { id: 2, name: 'Catalán', "code": "ca" },
    { id: 3, name: 'Inglés', "code": "en" },
    { id: 4, name: 'Alemán', "code": "de" },
    { id: 5, name: 'Francés', "code": "fr" },
    { id: 6, name: 'Italiano', "code": "it" },
    { id: 7, name: 'Holandés', "code": "nl" },
    { id: 8, name: 'Portugués', "code": "pt" },
    { id: 9, name: 'Ruso', "code": "ru" },
    { id: 10, name: 'Polaco', "code": "pl" },
    { id: 11, name: 'Sueco', "code": "sv" },
    { id: 12, name: 'Árabe', "code": "ar" }
];